<template>
  <footer
    class="tw-flex tw-flex-col tw-items-center tw-justify-between tw-space-x-8 tw-space-y-2 tw-p-3 tw-text-xs tw-text-neutral-400 sm:tw-flex-row sm:tw-space-y-0"
  >
    <div>© {{ currentYear }} Growth Tonic LLC. All rights reserved.</div>
    <div>
      Made with
      <span class="tw-text-error-500">❤️</span>
      in Glyfada
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear()
</script>
